<app-modal
  [title]="'Cineville partner code' | trans:'cart/cineville-partner-code-modal/header/title'"
  maxWidth="480px"
  width="100%"
>
  <ng-template>
    <div>
      @if (isLoading()) {
        <div class="d-flex justify-content-center align-items-center">
          <app-loader size="lg" />
        </div>
      } @else {
        @if (data?.pendingTicket) {
          <p class="p2 m-b-8">
            <span class="fw-semibold">{{ data.targetCategoryName }}</span>
          </p>
          <p class="p2 m-b-16">
            {{ 'Row' | trans:'cart/ticket/row.Label' }}
            <b>{{ data.pendingTicket.seatRow }}</b>
            /
            {{ 'Seat' | trans:'cart/ticket/seat.Label' }}
            <b>{{ data.pendingTicket.seatNr }}</b>
          </p>
        }

        <app-form-control [label]="'Partner code' | trans:'cart/cineville-partner-code-modal/code.Label'">
          <input
            #codeInput
            type="text"
            name="cinevilleCode"
            [(ngModel)]="code"
            autocomplete="off"
          />
        </app-form-control>
      }
    </div>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        type="button"
        (click)="close()"
      >
        {{ 'Cancel' | trans:'cart/cineville-partner-code-modal/cancel.Button' }}
      </button>
      <button
        #confirmBtn
        class="button button--md button--primary text-uppercase"
        type="button"
        [disabled]="!code?.trim() || isLoading()"
        (click)="confirmCategoryChange()"
      >
        {{ 'Confirm' | trans:'cart/cineville-partner-code-modal/confirm.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>
